/* eslint-disable react/button-has-type */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import withUserAgent from 'containers/withUserAgent';
import Small from './Small';
import './Tooltip.scss';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.uniqueId = props.id || _.uniqueId('tooltip-');
  }

  render() {
    const {
      text,
      primary,
      position,
      children,
      userAgent,
      as,
    } = this.props;

    // Need to add these on iOS mobile only
    const mobileProps = userAgent.isiPhone
      ? { event: 'click', globalEventOff: 'touchstart' }
      : {};
    const classes = {
      tooltip: true,
      primary,
      mobile: userAgent.isMobile && !userAgent.isTablet,
    };

    if (text) {
      const content = (
        <ReactTooltip
          id={this.uniqueId}
          class="react-tooltip"
          place={position}
          position={position}
          effect="solid"
          {...mobileProps}
        >
          <Small>
            {text}
          </Small>
        </ReactTooltip>
      );
      switch (as) {
        case 'div':
          return (
            <div data-tip data-for={this.uniqueId} className={classNames(classes)}>
              { children }
              { content }
            </div>
          );
        default:
          return (
            <button data-tip data-for={this.uniqueId} className={classNames(classes)}>
              { children }
              { content }
            </button>
          );
      }
    }
    return (
      <Fragment>
        { children }
      </Fragment>
    );
  }
}

Tooltip.defaultProps = {
  id: null,
  primary: false,
  position: 'bottom',
  children: null,
  userAgent: {},
  as: 'button',
};

Tooltip.propTypes = {

  id: PropTypes.string,

  /** Tooltip text */
  text: PropTypes.string.isRequired,

  /** Style primary */
  primary: PropTypes.bool,

  /** Tooltip position */
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),

  children: PropTypes.node,

  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool,
    isiPhone: PropTypes.bool,
    isTablet: PropTypes.bool,
  }),

  as: PropTypes.oneOf(['button', 'div']),
};

export default withUserAgent(Tooltip);
